var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{class:[_vm.$style.path, ( _obj = {}, _obj[_vm.$style.isDark] = _vm.isDark, _obj )],attrs:{"data-luko-tracking":"Breadcrumb"}},_vm._l((_vm.crumbs),function(crumb,crumbIndex){return _c('li',{key:crumbIndex},[_c('a',{attrs:{"href":crumb.url}},[_vm._v(_vm._s(crumb.name))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }